import React, { useMemo, useState } from "react";
import Plan from "./Plan";
import { BillingPeriodTabs } from "../BillingPeriodTabs";
import plans from "../../data/plans";
import logo from "../../logo.svg";

import * as cl from "./Plans.module.css";
import { getMediaUrl } from "../../utils/utils";
import BrowserLink from "../BrowserLink";

const Plans = ({ analyticsData, userAccess, planSet }) => {
  const [isYearly, setIsYearly] = useState(true);

  const activePremium = userAccess.includes("pc");
  const isGuest = userAccess === 'guest';
  const isOnlyPremiumMode = activePremium || planSet === 'premium';

  function handleChangePlansType(isYealy) {
    setIsYearly(isYealy);
  }

  const handleSignInClick = (e) => {
    window.showPopupLogin();
    e.preventDefault();
  }

  const renderPlans = useMemo(() => {
    return (
      <div className={cl.premiumRow}>
        <div>
          <Plan analyticsData={analyticsData} isYearly={false} data={plans.premium} className={cl.planItem} />
        </div>
        <div>
          <Plan analyticsData={analyticsData} isYearly={true} data={plans.premium} className={cl.planItem} />
        </div>
      </div>
    )
    return (
      <>
        <Plan analyticsData={analyticsData} isYearly={false} data={plans.premium} className={cl.planItem} />
        <Plan analyticsData={analyticsData} isYearly={true} data={plans.premium} className={cl.planItem} />
      </>
    )
  }, [isOnlyPremiumMode, isGuest, analyticsData, isYearly])

  return (
    <section className={cl.plans}>
      <div className={cl.content}>

        <img src={getMediaUrl(logo)} alt="Logo" className={cl.logo} />

        <p className={cl.heading}>Choose Your Plan And Start <span className={cl.green}>CRUSHING</span> The Game With Team PokerCoaching!</p>
        {isGuest && <p className={cl.signin}>Already a Member? <BrowserLink className={cl.signinLink} href="/" onClick={handleSignInClick}>Sign in</BrowserLink></p>}
        <p className={cl.description}>Save $348/year with the &lsquo;Annual&rsquo; plan</p>

        <div className={cl.plansSection}>
          {renderPlans}
        </div>
      </div>
    </section>
  )
}

export default Plans
